import React, {useState} from "react";
import authAxios from "../api/axios";
import {
  fnDeleteSubjectID,
  fnFetchAllSubject,
  fnFetchSubjectID,
  fnModifyAsyncNoRedirect,
  fnModifyAsyncRedirect,
  fnPostAsyncRedirect,
  fnPostToSubject
} from "./CrudContextProviderUtil";

export const LocationDataContext = React.createContext();

export const fnModifyLocationCustomer = (
  axiosObj,
  path,
  errorStateSetter = function (e) {
    console.log(e);
  }
) => {
  return (subjectID, postObj, navigate) => {
    axiosObj
      .put(`/api/${path}/${subjectID}`, postObj)
      .then((res) => {
        navigate(`/locations/${subjectID}`);
      })
      .catch((err) => errorStateSetter(err));
  };
};

export default function UserDataProvider(props) {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <LocationDataContext.Provider
      value={{
        modifyLocationAsync: fnModifyAsyncRedirect(authAxios, "location"),
        modifyLocationAsyncNon: fnModifyAsyncNoRedirect(authAxios, "location"),
        fetchAllLocationAsync: fnFetchAllSubject(authAxios, "location", e => {
          console.log(e)
        }, setIsLoading),
        fetchLocationAsync: fnFetchSubjectID(authAxios, "location"),
        fetchAllLocationComments: fnFetchSubjectID(authAxios, "location/note/fetchall"),
        postLocationComment: fnPostToSubject(authAxios, "location/note"),
        deleteLocationComment: fnDeleteSubjectID(authAxios, "location/note"),
        postNewLocation: fnPostToSubject(authAxios, "location"),
        fetchLocationCustomersAsync: fnFetchSubjectID(authAxios, "maplocationcustomer/location"),
        fetchAllCustomerAsync: fnFetchAllSubject(authAxios, "customer"),
        modifyCustomerAsyncNon: fnModifyAsyncNoRedirect(authAxios, "customer"),
        fetchAllLocationWorkOrders: fnFetchSubjectID(authAxios, "location/workorders"),
        fetchCustomerDataEditPage: fnFetchSubjectID(authAxios, "location"),
        fnModifyCustomerData: fnModifyLocationCustomer(authAxios, "location"),
        fnDeleteSubjectID: fnDeleteSubjectID(authAxios, "location"),
        fnPostAsyncRedirect: fnPostAsyncRedirect(authAxios, "location"),
        isLoading
      }}
    >
      {props.children}
    </LocationDataContext.Provider>
  );
}
